module.exports = __webpack_public_path__ + "static/media/btn-mailnotify.d58a43f9.svg";